import { render, staticRenderFns } from "./PlaceOfTalk.vue?vue&type=template&id=53313239&"
import script from "./PlaceOfTalk.vue?vue&type=script&lang=js&"
export * from "./PlaceOfTalk.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports